import HTTP from "./axios";
const resource = "/fmx";

export default {
  /**
   * Create new file
   * @param disk
   * @param path
   * @param name
   * @returns {AxiosPromise<any>}
   */
  createFile(disk, path, name) {
    return HTTP.post(`${resource}/create-file`, { disk, path, name });
  },

  /**
   * Update file
   * @param formData
   * @returns {*}
   */
  updateFile(formData) {
    return HTTP.post(`${resource}/update-file`, formData);
  },

  /**
   * Create new directory
   * @param data
   * @returns {*}
   */
  createDirectory(data) {
    return HTTP.post(`${resource}/create-directory`, data);
  },

  /**
   * Upload file
   * @param data
   * @param config
   * @returns {AxiosPromise<any>}
   */
  upload(data, config) {
    return HTTP.post(`${resource}/upload`, data, config);
  },

  /**
   * Delete selected items
   * @param data
   * @returns {*}
   */
  delete(data) {
    return HTTP.post(`${resource}/delete`, data);
  },

  /**
   * Rename file or folder
   * @param data
   * @returns {*}
   */
  rename(data) {
    return HTTP.post(`${resource}/rename`, data);
  },

  /**
   * Copy / Cut files and folders
   * @param data
   * @returns {*}
   */
  paste(data) {
    return HTTP.post(`${resource}/paste`, data);
  },

  /**
   * Zip
   * @param data
   * @returns {*}
   */
  zip(data) {
    return HTTP.post(`${resource}/zip`, data);
  },

  /**
   * Unzip
   * @returns {*}
   * @param data
   */
  unzip(data) {
    return HTTP.post(`${resource}/unzip`, data);
  }
};
